import { Menu, entities } from '../models/menuModel';

export const MENUITEMS: Menu[] = [
  {
    id: 1,
    visible: false,
    categoria: 'Componentes transversales',
    categoriaDetalle: 'Componentes Transversales',
    alias: 'transversal',
    dependencias: [
      entities.portalGovCo,
      entities.sedesElectronicas,
      entities.tramitesServicios,
      entities.ventanillasUnicas,
      entities.portalesTransversales,
    ],
    recursos: [
      {
        id: 1.1,
        visible: true,
        nombreRecurso: 'Barra de accesibilidad',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
          entities.ventanillasUnicas,
          entities.portalesTransversales,
        ],
        url: 'transversal/barra-accesibilidad',
        alias: '',
      },
      {
        id: 1.7,
        visible: false,
        nombreRecurso: 'Barra superior',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
          entities.ventanillasUnicas,
          entities.portalesTransversales,
        ],
        url: 'transversal/barra-superior',
        alias: '',
      },
      {
        id: 1.2,
        visible: false,
        nombreRecurso: 'Color',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'transversal/color',
        alias: '',
      },
      {
        id: 1.8,
        visible: false,
        nombreRecurso: 'Cabecera',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'transversal/cabecera',
        alias: '',
      },
      {
        id: 1.3,
        visible: false,
        nombreRecurso: 'Iconografía',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'transversal/iconografia',
        alias: '',
      },
      {
        id: 1.8,
        visible: false,
        nombreRecurso: 'Pie de página',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'transversal/pie-de-pagina',
        alias: '',
      },
      {
        id: 1.5,
        visible: false,
        nombreRecurso: 'Tipografía',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
          entities.ventanillasUnicas,
          entities.portalesTransversales,
        ],
        url: 'transversal/tipografia',
        alias: '',
      },
      {
        id: 1.6,
        visible: false,
        nombreRecurso: 'Volver arriba',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
          entities.ventanillasUnicas,
          entities.portalesTransversales,
        ],
        url: 'transversal/volver-arriba',
        alias: '',
      },
    ],
  },
  {
    id: 2,
    visible: false,
    categoria: 'Componentes generales',
    categoriaDetalle: 'Componentes generales',
    alias: 'general',
    dependencias: [
      entities.portalGovCo,
      entities.sedesElectronicas,
      entities.tramitesServicios,
    ],
    recursos: [
      {
        id: 2.24,
        visible: false,
        nombreRecurso: 'Acordeón',
        dependencias: [entities.sedesElectronicas],
        url: 'general/acordeon',
        alias: '',
      },
      {
        id: 2.1,
        visible: false,
        nombreRecurso: 'Alerta modal',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/alerta-modal',
        alias: '',
      },
      {
        id: 2.2,
        visible: false,
        nombreRecurso: 'Alerta notificación',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/alerta-notificacion',
        alias: '',
      },
      {
        id: 2.18,
        visible: false,
        nombreRecurso: 'Área de servicio',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/area-de-servicio',
        alias: '',
      },
      {
        id: 2.5,
        visible: false,
        nombreRecurso: 'Botones',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/botones',
        alias: '',
      },
      {
        id: 2.3,
        visible: false,
        nombreRecurso: 'Buscador',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/buscador',
        alias: '',
      },
      {
        id: 2.19,
        visible: false,
        nombreRecurso: 'Galería de aplicaciones',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/galeria-de-aplicaciones',
        alias: '',
      },
      {
        id: 2.2,
        visible: false,
        nombreRecurso: 'Carrusel',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/carrusel',
        alias: '',
      },
      {
        id: 2.24,
        visible: false,
        nombreRecurso: 'Descripción emergente',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/descripcion-emergente',
        alias: '',
      },
      {
        id: 2.9,
        visible: false,
        nombreRecurso: 'Etiquetas',
        dependencias: [entities.portalGovCo, entities.sedesElectronicas],
        url: 'general/etiquetas',
        alias: '',
      },
      {
        id: 2.1,
        visible: false,
        nombreRecurso: 'Indicador de carga',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/indicador-de-carga',
        alias: '',
      },
      {
        id: 2.21,
        visible: false,
        nombreRecurso: 'Línea de avance',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/linea-de-avance',
        alias: '',
      },
      {
        id: 2.22,
        visible: false,
        nombreRecurso: 'Menú de navegación',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/menu-de-navegacion',
        alias: '',
      },
      {
        id: 2.11,
        visible: false,
        nombreRecurso: 'Miga de pan',
        dependencias: [entities.tramitesServicios, entities.sedesElectronicas],
        url: 'general/miga-de-pan',
        alias: '',
      },
      {
        id: 2.13,
        visible: false,
        nombreRecurso: 'Módulo de inicio de sesión',
        dependencias: [entities.portalGovCo],
        url: 'general/login',
        alias: '',
      },
      {
        id: 2.14,
        visible: false,
        nombreRecurso: 'Paginación',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/paginacion',
        alias: '',
      },
      {
        id: 2.15,
        visible: false,
        nombreRecurso: 'Pestañas',
        dependencias: [entities.portalGovCo, entities.sedesElectronicas],
        url: 'general/tab',
        alias: '',
      },
      {
        id: 2.16,
        visible: false,
        nombreRecurso: 'Tablas',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/tablas',
        alias: '',
      },
      {
        id: 2.23,
        visible: false,
        nombreRecurso: 'Tarjetas de información',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'general/tarjetas-de-informacion',
        alias: '',
      },
    ],
  },
  {
    id: 3,
    visible: false,
    categoria: 'Componentes de formulario',
    categoriaDetalle: 'Componentes de formulario',
    alias: 'form',
    dependencias: [
      entities.portalGovCo,
      entities.sedesElectronicas,
      entities.tramitesServicios,
    ],
    recursos: [
      {
        id: 3.4,
        visible: false,
        nombreRecurso: 'Carga de archivo',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'form/carga-de-archivo',
        alias: '',
      },
      {
        id: 3.2,
        visible: false,
        nombreRecurso: 'Desplegables',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'form/desplegables',
        alias: '',
      },
      {
        id: 3.1,
        visible: false,
        nombreRecurso: 'Entradas de texto',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'form/entradas-de-texto',
        alias: '',
      },
      {
        id: 3.3,
        visible: false,
        nombreRecurso: 'Opciones de selección',
        dependencias: [
          entities.portalGovCo,
          entities.sedesElectronicas,
          entities.tramitesServicios,
        ],
        url: 'form/opciones-de-seleccion',
        alias: '',
      },
    ],
  },
];
